import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {CandidateProfile} from "../dto/candidate-profile";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CandidateProfileService {
  private url = environment.apiUrl;
  candidateProfile: CandidateProfile;
  isUnauthorized:BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(private http: HttpClient) { }


  getCandidateProfile(key: string, hash: string, reference: string) {
    const timezone = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const params: any = { timezone };
    if (reference) {
      params.reference = reference;
    }
    return this.http.get<CandidateProfile>(this.url +`/rest/candidate-profile/2.0/${key}/${hash}`,
      { params });
  }
  downloadFile(key: string, hash: string) {
    return this.http.get(this.url + `/rest/candidate-profile/2.0/${key}/${hash}/download-file`, {responseType: 'blob'});
  }

}
